import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useLocation,
  Outlet,
} from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import WebsiteSelector from './components/WebsiteSelector';
import WebBuilder from './WebBuilder';
import Statistics from './components/Statistics';
import './App.css';

function LoginScreen() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f5f7fb' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ marginBottom: 8 }}>Landing Page Creator</h1>
        <p style={{ marginBottom: 16, color: '#4b5563' }}>Sign in to continue</p>
        <button onClick={() => loginWithRedirect()} style={{ padding: '10px 18px', cursor: 'pointer' }}>
          Sign In
        </button>
      </div>
    </div>
  );
}

function CallbackPage() {
  const { isLoading, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      window.location.replace('/');
    }
  }, [isLoading, isAuthenticated]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <p>Completing sign in...</p>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return children;
}

function PageTitleManager() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/editor/') && location.pathname.endsWith('/statistics')) {
      document.title = 'Statistics | Landing Page Creator';
      return;
    }

    if (location.pathname.startsWith('/editor/')) {
      document.title = 'Editor | Landing Page Creator';
      return;
    }

    if (location.pathname === '/callback') {
      document.title = 'Signing In | Landing Page Creator';
      return;
    }

    document.title = 'Landing Page Creator';
  }, [location.pathname]);

  return null;
}

function AppShell() {
  const { isAuthenticated, logout } = useAuth0();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="App">
      <PageTitleManager />
      {isAuthenticated && isHomePage && (
        <div style={{ position: 'fixed', top: 10, right: 10, zIndex: 10000 }}>
          <button
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            style={{ padding: '6px 10px', cursor: 'pointer' }}
          >
            Logout
          </button>
        </div>
      )}
      <Outlet />
    </div>
  );
}

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: '/callback', element: <CallbackPage /> },
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <WebsiteSelector />
          </ProtectedRoute>
        ),
      },
      {
        path: '/editor/:websiteId',
        element: (
          <ProtectedRoute>
            <WebBuilder />
          </ProtectedRoute>
        ),
      },
      {
        path: '/editor/:websiteId/statistics',
        element: (
          <ProtectedRoute>
            <Statistics />
          </ProtectedRoute>
        ),
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
